export const backendUrl = process.env.VUE_APP_BACKEND_API_URL;
export const storageUrl = process.env.VUE_APP_STORAGE_API_URL;
export const cdnUrl = process.env.VUE_APP_CDN_URL;
export const pusherKey = process.env.VUE_APP_PUSHER_KEY;
export const pusherCluster = process.env.VUE_APP_PUSHER_CLUSTER;
export const googleMapApiKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
export const dsAppDomainUrl = process.env.VUE_APP_DS_DOMAIN_URL;
export const sciAppDomainUrl = process.env.VUE_APP_SCI_APP_DOMAIN_URL;
